// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap
import './index.css'; // Design tokens & fonts
import './App.css'; // Custom CSS

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
